/*
 * @Author: LiGang
 * @Date: 2026-06-02 10:28:43
 * @LastEditors: LG liganglig@outlook.com
 * @LastEditTime: 2026-06-23 12:07:57
 * @FilePath: /chezhu-h5-dev/config/pyunConfig.js
 * @Description:
 *
 * Copyright (c) 2026 by ${git_name_email}, All Rights Reserved.
 */
/**
 * P云广告SDK配置
 * 文档: https://doc.4pyun.com/openapi/api/adverting-jsapi.html
 *
 * 广告位 ID 配置在 config/adConfig.js 中（三家广告源统一管理）
 */

import * as envsetting from '../config/envsetting'

// 调试配置
// debugPanel: 控制页面调试面板显示 (true: 显示, false: 隐藏)
// debugConsole: 控制台日志级别 ('error': 只输出错误, 'warn': 警告+错误, 'info': 全部, 'off': 关闭所有)
export const debugPanel = false
export const debugConsole = 'info' // 上线后改 'error'

// P云分配的接入应用ID
export const pyunAppId = 'op62316df26614ef7'

// 特惠券包广告位ID（PayMoney.vue 拦截支付流程时的默认 spaceId）
export const pyunSpaceId = '869969967989137408'

// 育恩科技测试P云商户号（券包所需，固定值）
export const pyunMerchant = '12273423'

// 流量主编号 (使用车场SID，调用时动态传入)
export const pyunProviderCode = ''

// 流量主信息同步回调地址
export const pyunProviderUrl = envsetting.parkcloudServerName + '/PPAdGetParkInfo'

// P云 SDK 地址
export const pyunSdkUrl = 'https://assets.4pyun.com/js/4pyun-sdk-1.2.1.min.js'

// 外部流量主标志
export const pyunExternal = 1
